import React, {useEffect, useState} from 'react';
import '../../../styles/Commons.css';
import {Card, Checkbox, Col, Row, Table} from "antd";
import {User} from "../../../model/root/User";
import {Escola} from "../../../model/root/Escola";
import {ColumnsType} from "antd/es/table";
import {Rol} from "../../../model/root/Rol";
import {UsuariRolEscoles} from "../../../model/root/UsuariRolEscoles";
import {PutEscolaUsuari} from "../../../dao/root/PutEscolaUsuari";
import {PutRolUsuari} from "../../../dao/root/PutRolUsuari";
import {Pagina} from "../../../model/root/Pagina";
import {PutPaginaRol} from "../../../dao/root/PutPaginaRol";

interface element {
    element: Rol,
    elements: UsuariRolEscoles,
    page: string,
    checkDades: () => void;
}

const UsuarisList = (ele: element) => {

    async function togglePermisVeure(id_pagina: number) {
        await PutPaginaRol(id_pagina, ele.element.id, false, ele.page);
        await ele.checkDades();
    }

    async function togglePermisEditar(id_pagina: number) {
        await PutPaginaRol(id_pagina, ele.element.id, true, ele.page);
        await ele.checkDades();
    }

    const columns: ColumnsType<Pagina> = [
        {
            key: 'id',
            title: 'ID',
            dataIndex: 'id',
            width: 15,
            responsive: ['lg'],
            sorter: (a, b) => a.id - b.id,
        },
        {
            key: 'nom',
            title: 'Nom',
            dataIndex: 'nom',
            width: 30,
            filterSearch: true,
        },
        {
            key: 'accions', title: 'Visualitzar', dataIndex: 'accions', width: 30,
            render: (estat, el) => (
                <>
                    <Checkbox type={"toggle"}
                              disabled={el.nom === 'pantalles' || el.nom === 'bundles' || ele.element.nom.lastIndexOf("superusuari") !== -1}
                              checked={ele.element.pagines && ele.element.pagines.some((pag : Pagina) => pag.id === el.id)}
                              onClick={() => togglePermisVeure(el.id)}/>
                </>
            ),
        },
        {
            key: 'accions', title: 'Modificar', dataIndex: 'accions', width: 30,
            render: (estat, el) => (
                <>
                    <Checkbox type={"toggle"}
                              disabled={el.nom === 'pantalles' || el.nom === 'bundles' || ele.element.nom.lastIndexOf("superusuari") !== -1}
                              checked={ele.element.pagines && ele.element.pagines.some((pag : Pagina) => pag.id === el.id && pag.visible === 1)}
                              onClick={() => togglePermisEditar(el.id)}/>
                </>
            ),
        },
    ];

    return (
        <Card bordered={true}>
            <Row gutter={16}>
                <Col className="gutter-row" span={2}>
                </Col>
                <Col className="gutter-row" span={20}>
                    <h4 className={"subsubtitol"}>Pagines i permisos</h4>
                    <Table tableLayout={"fixed"}
                        size={"small"}
                        columns={columns}
                        dataSource={ele.elements.pagines}
                    />
                </Col>
                <Col className="gutter-row" span={2}>
                </Col>
            </Row>
        </Card>
    );
};
export default UsuarisList;
